﻿/*
* Dialog service class.
* Show dialog modal such as 'confirm' dialog
*/


import { Injectable } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmComponent, ConfirmOptions } from '../component/modals/confirm/confirm.component';

@Injectable()
export class DialogService {

    //#region constructor

    constructor(private service: NgbModal) { }

    //#endregion

    //#region public methods

    public confirm = (options?: ConfirmOptions) => {


        let modal = this.service.open(ConfirmComponent);
        let component: ConfirmComponent = modal.componentInstance;
        component.options = options;

        return modal.result;

    }

    //#endregion


}